<template>
  <div class="head">
    <div class="header">
      <div class="title_log" ><img @click="changeEn" alt="" src="../../static/title_logo.png" /></div>
      <div class="left" v-if="lang == 'zh'">
        <div class="img"><img alt="" src="../../static/logo.png" /></div>
        <div class="txt">
          <p class="p1">{{ $t('viewDetail.title') }}</p>
          <p class="p2">{{ $t('viewDetail.theme') }}</p>
          <p class="p3">{{ $t('viewDetail.time') }}</p>
        </div>
      </div>
      <div class="center">
        <ul>
          <div class="hyperlinks" to="index">
            <li>{{ $t('viewDetail.home') }}</li>
          </div>
          <div class="hyperlinks" to="exhibition">
            <li>{{ $t('viewDetail.exhibition') }}</li>
          </div>
          <div class="hyperlinks" to="exhibitsList">
            <li>{{ $t('viewDetail.exhibits') }}</li>
          </div>
          <div class="hyperlinks" to="live">
            <li>{{ $t('viewDetail.live') }}</li>
          </div>
          <div class="hyperlinks" to="active">
            <li>{{ $t('viewDetail.activity') }}</li>
          </div>
          <div class="hyperlinks" to="#">
            <li class="li">
              {{ $t('viewDetail.onlineHall') }}
              <div class="menu">
                <div to="#">
                  <p>{{ $t('viewDetail.VRview') }}</p>
                </div>
               
                <div to="#">
                  <p>{{ $t('viewDetail.imgView') }}</p>
                </div>


                <div to="#">
                  <p>{{ $t('viewDetail.videoView') }}</p>
                </div>
              </div>
            </li>
          </div>
          <div class="hyperlinks" to="#">
            <li>{{ $t('viewDetail.onlineWeb') }}</li>
          </div>
        </ul>
      </div>
      <div class="right">
        <div
          class="login"
          :style="{
            padding: lang == 'zh' ? '0px 17px ' : '0px 3px',
            boxSizing: 'boder-box',
          }"
        >
          {{ $t('viewDetail.audienceLogin') }}
        </div>
        <div
          class="login"
          :style="{
            padding: lang == 'zh' ? '0px 17px ' : '0px 3px',
            boxSizing: 'boder-box',
          }"
        >
          {{ $t('viewDetail.exhibitionLogin') }}
        </div>
        <!-- <div class="language" @click="changeLang()"> -->
        <div class="language">
          <div class="chese" v-if="toggle">
            {{ $t('viewDetail.zh') }}
          </div>
          <div class="english" v-else>
            {{ $t('viewDetail.en') }}
          </div>
        </div>
      </div>
    </div>
    <div class="viewTitle">
      <span>{{ $t('viewDetail.viewEffect') }}</span>
    </div>
  </div>
</template>

<script>
import {backFront} from '../../../utils/common'
export default {
  data() {
    return {
      toggle: false,
      lang: '',
      backFront:backFront()   //线上展会首页
    };
  },
  created() {
    const language = localStorage.getItem('lang');
    this.$i18n.locale = language == 'en' ? language : 'zh';
    this.lang = language ? language : 'zh';
    this.toggle = language == 'en' ? true : false;
  },
  methods: {
    changeLang(e) {
      if (this.toggle == true) {
        // 当前显示的是中文图标,说明页面内容是英文,
        // todo: 把图标变为英文图标，内容变为中文
        this.toggle = false;
        localStorage.setItem('lang', 'zh');
        this.$i18n.locale = 'zh';
        this.lang = 'zh';
        // 存到localStorage的语言是zh
      } else if (this.toggle == false) {
        // 当前显示的是英文图标,说明页面内容是中文,
        // todo: 把图标变为中文图标，内容变为英文
        this.toggle = true;
        localStorage.setItem('lang', 'en');
        this.$i18n.locale = 'en';
        this.lang = 'en';
        // 存到localStorage的语言是en
      }
      window.location.reload();
    },
    changeEn(){
      console.log("点击了",this.backFront);
      window.open(this.backFront)
    }
  },
};
</script>

<style lang="scss" scoped>
.head {
  width: 100%;
  // opacity: 1;
  // position: fixed;
  // top: 0px;
  // left: 0px;
  // z-index: 99;
  .header {
    height: 100%;
    height: 100px;
    display: flex;
    align-items: center;
    margin: 0 auto;
    background-color: rgba(0, 111, 184);

    .left {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-left: 20px;

      .img {
        width: 87px;
        height: 86px;
      }

      .txt {
        width: 440px;
        margin-left: 15px;

        .p1 {
          display: block;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #ffffff;
          line-height: 26px;
        }

        .p2 {
          display: block;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #ffffff;
        }

        .p3 {
          font-size: d 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }

    .center {
      height: 100%;
      position: relative;
      margin-left: 160px;

      ul {
        height: 100%;
        list-style: none;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .hyperlinks {
          text-decoration: none;
          display: block;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 25px;
          cursor: pointer;

          .li {
            position: relative;

            padding-bottom: 20px;
            position: relative;
            top: 10px;
            box-sizing: border-box;

            .menu {
              display: none;
              position: absolute;
              left: -18px;
              top: 40px;
              color: black;
              border-top: 3px solid #fdd000;
              box-shadow: 0px 0px 51px 0px #e8ecf0;
              width: fit-content;
              width: 105px;
              background-color: white;
              //a {
              div {
                text-decoration: none;

                p {
                  height: 36px;
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #333333;
                  text-align: center;
                  line-height: 36px;

                  &:hover {
                    color: #006fb8;
                    background: #ededed;
                  }
                }
              }
            }

            &:hover {
              .menu {
                display: block;
              }
            }
          }
        }

        li {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          white-space: nowrap;
        }

        li:hover {
          color: #fccf00;
        }
      }
    }

    .right {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-left: 26px;

      .login {
        height: 37px;
        border: 1px solid #ffffff;
        border-radius: 4px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 37px;
        margin-left: 4px;
      }

      .language {
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        display: flex;
        margin-left: 5px;
        cursor: pointer;

        .chese {
          margin-left: 9px;
          margin-right: 5px;
          padding-right: 5px;
          white-space: nowrap;

          img {
            vertical-align: middle;
          }
        }

        .english {
          margin-left: 9px;
          margin-right: 5px;
          padding-right: 5px;
          white-space: nowrap;

          img {
            vertical-align: middle;
          }
        }
      }
    }
  }

  .viewTitle {
    width: 100%;
    height: 60px;
    background-color: rgba(253, 208, 0, 0.15);
    border: 0px solid #e0e0e0;
    border-radius: 1px;
    padding-left: 275px;
    box-sizing: border-box;
    line-height: 60px;

    span {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #fdd000 !important;
    }
  }
}
</style>
